<sl-label size="large" i18n>API Keys</sl-label>

<div class="grid">
    <sl-alert type="info" open>
        <span i18n>These keys will allow you to authenticate API requests.</span><br>
        <a href="https://docs.previsto.com/help/integration-til-previsto/api-keys" target="_BLANK" i18n>Learn more.</a>
    </sl-alert>
    <sl-list lines="full" class="mt-4" *ngIf="keys">
        <sl-list-item *ngFor="let key of keys">
            <sl-label>{{key.name}}</sl-label>
            <sl-label size="small" color="dark">{{key.key}}</sl-label>  
        </sl-list-item>
    </sl-list>
    <sl-button *ngIf="keys?.length ?? 0 > 0"class="mt-4" (click)="regenerateKeys()" i18n>Regenerate Keys</sl-button>
    <sl-button *ngIf="keys?.length === 0" class="mt-4" (click)="regenerateKeys()" i18n>Generate Keys</sl-button>
</div>
 